import Vuex from 'vuex'
import axios from 'axios';
import Vue from 'vue'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        name: localStorage.getItem('name'),
        token: localStorage.getItem('token'),
        user: localStorage.getItem('user'),
        cargo: localStorage.getItem('cargo'),
        profile_picture: localStorage.getItem('profile_picture'),
        cargo_id: localStorage.getItem('cargo_id'),
        tab_id: localStorage.getItem('tab_id'),

        videourl: localStorage.getItem('videourl'),
    },

    getters: {
        isAuthenticated: state => !!state.token,
        name: state => state.name,
        token: state => state.token,
        user: state => state.user,
        cargo: state => state.cargo,
        profile_picture : state => state.profile_picture,
        cargo_id: state => state.cargo_id,
        tab_id: state => state.tab_id,

        videourl: state => state.videourl,

        isAdmin: state => state.cargo == 'admin',
        isDiretor: state => state.cargo == 'diretor',
        isCorretor: state => state.cargo == 'corretor',
        isAluno: state => state.cargo == 'aluno',
        isProfessor: state => state.cargo == 'professor',
    },

    mutations: {
        login(state, data) {
            state.name = data.user.name
            state.token = data.access_token
            state.user = data.user.id
            state.cargo = data.user.cargo
            state.cargo_id = data.user.cargo_id
            state.profile_picture = data.user.profile_picture

            localStorage.setItem('name', data.user.name)
            localStorage.setItem('token', data.access_token)
            localStorage.setItem('user', data.user.id)
            localStorage.setItem('cargo', data.user.cargo)
            localStorage.setItem('profile_picture', data.user.profile_picture)
            localStorage.setItem('cargo_id', data.user.cargo_id)
            localStorage.setItem('tab_id', "1")
            

            

            axios.defaults.headers.common['Authorization'] = 'Bearer ' + state.token
        },

        logout(state) {
            state.name = null
            state.token = null
            state.user = null
            state.cargo = null
            state.cargo_id = null
            state.videourl = null
            state.profile_picture = null



            localStorage.removeItem('name')
            localStorage.removeItem('token')
            localStorage.removeItem('user')
            localStorage.removeItem('cargo')
            localStorage.removeItem('profile_picture')
            localStorage.removeItem('cargo_id')
            localStorage.removeItem('tab_id')
            localStorage.removeItem('videourl')

            delete axios.defaults.headers.common['Authorization']
        },
    },

    actions: {
    }
});